// extracted by mini-css-extract-plugin
module.exports = {"inviteButton":"styles-module__inviteButton___3Sp3Y","inviteContainer":"styles-module__inviteContainer___1ac6L"};